module.exports = __webpack_public_path__ + "img/pin.8c21d124.svg";